'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.sa_group_index', {
    url: 'sa_group',
    template: '<sa-group-index></sa-group-index>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/sa_group/index/sa_group_index.routes.js